// extracted by mini-css-extract-plugin
module.exports = {"card":"DocumentReferences_card__1V_9G"};